export default __webpack_public_path__ + "respweb/static/images/red-heart-gift6fe6150b46333d65e906d8ef724ea636.png";